<template>
  <div class="message-quote">
    <div class="message-quote__content">
      <p class="content-title">{{ quoteTitle.name ? `${quoteTitle.name}:` : '' }}</p>
      <p class="content-text">{{ quoteTitle.text }}</p>
    </div>
    <div class="message-quote__name">{{ quoteText }}</div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  message: {
    type: Object,
    default: () => ({
      content: '',
      title: {
        name: '',
        text: '',
        type: undefined
      }
    })
  }
})

const quoteTitle = computed(() => {
  const title = props.message.title
  if (title && typeof title === 'object' && !Array.isArray(title)) return title
  if (typeof title !== 'string') return { name: '', text: '' }

  try {
    const parsedTitle = JSON.parse(title)
    if (parsedTitle && typeof parsedTitle === 'object' && !Array.isArray(parsedTitle)) {
      return parsedTitle
    }
  } catch (error) {
    // 历史消息可能包含未按 JSON 编码的标题，直接展示原始文本。
  }

  return { name: '', text: title }
})

const quoteText = computed(() => {
  return props.message.content || ''
})
</script>

<style lang="scss" scoped>
.message-quote {
  box-sizing: border-box;
  padding: 8px 12px;
}

.message-quote__name {
  margin-top: 10px;
  font-size: 14px;
  line-height: 20px;
  color: #323233;
  word-break: break-all;
}
.message-quote__content {
  padding-left: 8px;
  border-left: 2px solid #e5e6eb;

  .content-title,
  .content-text {
    font-size: 12px;
    line-height: 16px;
    color: #969799;
    word-break: break-all;
  }
  .content-text {
    margin-top: 4px;
  }
}
</style>
